export default __webpack_public_path__ + "static/media/gym-banner.6884f778.jpg";